module.exports = __webpack_public_path__ + "static/media/Raleway-Italic.f73026bc.ttf";